import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useCurrentAssessmentCardStyles = () => {
    const theme = useTheme();
    const twoColumnGrid = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: theme.spacing(5) };
    const labelWithLevel = { display: "flex", alignItems: "center", gap: theme.spacing(1) };
    return createSxStyles({
        // A quiet gray reference panel (mirrors the gray "see changes" banner in the publish dialog), full-width
        // so it lines up with the scoring sections below it.
        root: {
            backgroundColor: theme.palette.grey[100],
            border: `1px solid ${theme.palette.grey[300]}`,
            borderRadius: `${theme.shape.borderRadius}px`,
            padding: theme.spacing(3),
        },
        // Risk level and exposure are both outcomes of the same assessment, so they share one headline row above
        // the per-dimension columns, on the same grid.
        summary: { ...twoColumnGrid, marginTop: theme.spacing(1) },
        summaryItem: labelWithLevel,
        assessedBy: {
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
            marginTop: theme.spacing(0.5),
        },
        divider: {
            marginY: theme.spacing(2),
        },
        dimensions: twoColumnGrid,
        dimension: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1.5),
        },
        titleLevel: labelWithLevel,
        label: {
            fontSize: "0.75rem",
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.text.secondary,
        },
        level: {
            fontSize: "0.75rem",
            fontWeight: 600,
            color: theme.palette.primary.dark,
        },
        chipsGroup: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(0.75),
        },
        chips: {
            display: "flex",
            flexWrap: "wrap",
            gap: theme.spacing(0.75),
        },
        justification: {
            fontSize: "0.8rem",
            fontStyle: "italic",
            lineHeight: 1.5,
            whiteSpace: "pre-wrap",
            color: theme.palette.text.secondary,
            paddingLeft: theme.spacing(1.5),
            borderLeft: `2px solid ${theme.palette.divider}`,
        },
        reviewNote: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(0.75),
        },
        reviewNoteText: {
            fontSize: "0.8rem",
            lineHeight: 1.5,
            whiteSpace: "pre-wrap",
            color: theme.palette.text.secondary,
        },
    });
};
